var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionBg1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1076,
    height: 969,
    viewBox: "0 0 1076 969",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M287.245 791.55C227.12 647.392 166.872 503.317 106.743 359.174C97.0181 336.053 107.947 309.567 131.134 299.778C268.283 242.069 366.095 213.946 507.797 152.726C545.619 138.854 626.98 115.67 720.971 141.434C882.1 185.619 946.506 337.007 957.989 364.086C992.963 446.051 992.243 520.924 988.622 561.766C758.466 658.805 574.189 721.241 347.001 816.02C323.857 825.708 296.967 814.68 287.244 791.552L287.245 791.55Z",
    fill: "url(#paint0_linear_1620_822)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1620_822",
    x1: 1075.78,
    y1: 236.499,
    x2: 124.918,
    y2: 593.686,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59C7C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FA9A7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionBg1);
export default __webpack_public_path__ + "static/media/section-bg-1.19b325f05d0aaa494a40aeeb95b65568.svg";
export { ForwardRef as ReactComponent };